<mat-dialog-content class="content">
  <div class="zeroState">
    <uikit-empty-state
      iconName="markunread_mailbox"
      [title]="'SIGN_UP.REGISTRATION_COMPLETE.TITLE' | translate"
      [ctaSecondaryText]="'COMMON.ACTION_LABELS.OKAY' | translate"
      (ctaSecondaryEvent)="accept()"
    >
      <span state-description>
        {{ 'SIGN_UP.REGISTRATION_COMPLETE.DESCRIPTION' | translate }}
      </span>
    </uikit-empty-state>
  </div>
</mat-dialog-content>
